import React from "react";
import Features from "../components/Features";

const Contact = () => {
  return <Features />;
};

export default Contact;
